import { makeStyles } from "@material-ui/core";

export default makeStyles(() => ({

    card: {
        
    },
    income: {
        // maxHeight: '500px',
        borderBottom: '10px solid rgba(0, 255, 0, 0.5)',
    },
    expense: {
        // maxHeight: '500px',
        borderBottom: '10px solid rgba(255, 0, 0, 0.5)',
    },
}));